import { render, staticRenderFns } from "./ViewPrepaymentAccount.vue?vue&type=template&id=5676b2a9&"
import script from "./ViewPrepaymentAccount.vue?vue&type=script&lang=js&"
export * from "./ViewPrepaymentAccount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports